import React, { useState, useEffect } from "react";
import axiosConfig from "../Service/axiosConfig";
import { MdDeleteOutline, MdOutlineEdit } from "react-icons/md";
import DataTable from "react-data-table-component";
import Masters from "../Components/masters.json";
import { DeletePopupModal, PopupModal, FormParser } from "../Components";
import { BiSearch } from "react-icons/bi";
import Modal from "react-bootstrap/Modal";
import { FaHandHoldingHeart } from "react-icons/fa";
import useDebouncedValue from "../Utils/Debounce";
import AlertDeletePopupModal from "../Components/PopupModal/AlertDeletePopupModal";
import { CMSNavbarComponent } from "../Components/navbar";
import { VendorsNav } from "../Components/navbar/VendorsNav";
const DailyCollection = () => {
  let today_date = (new Date()).toISOString().split('T')[0];
  const [Loading, setLoading] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const [modalTitle, setModalTitle] = useState("");
  const [LoadingButton, setLoadingButton] = useState();
  const [Data, SetData] = useState([]);
  const [message, setMessage] = useState("");
  const [show, setShow] = useState(false);
  const [RowPerPage, setRowPerPage] = useState(20);
  const [currentPage, setCurrentPage] = useState(1);
  const [formData, setFormData] = useState({
    "store":"",
    "date":today_date,
    "upi_sales":"",
    "cash_sales":"",
    "credit_sales":"",
    "credit_card_sales":"",
    "sodexo_sales":"",
    "pretty_payments_sales":"",
    "total_sales_value":"",
    "proof_images":""
  });
  const [popupType, setpopupType] = useState("");
  const [RowId, SetRowId] = useState();
  const MastersModal = Masters.DailyCollection;
  const [deletePopupType, setDeletepopupType] = useState("");
  const [Error, SetError] = useState();
  const [AlertDeletePopupType, SetAlertDeletePopupType] = useState("");
  const [search, SetSearch] = useState({
    search: "",
  });
  const debouncedSearchTerm = useDebouncedValue(search.search, 500);
  const HandleSearch = (e) => {
    e.preventDefault();
    const name = e.target.name;
    const value = e.target.value;
    console.log(name, value);
    SetSearch({ ...search, [name]: value });
  };
  const dailyCollection_columns = [
    {
      name: "ID",
      cell: (row, index) => index + 1,
    },
    {
      name: "Date",
      selector: "date",
      sortable: true,
    },
    {
      name: "Store",
      sortable: true,
      cell: (row) => row.store?.name || 'No Store',
    },
    {
      name: "UPI",
      selector: "upi_sales",
      sortable: true,
    },
    {
      name: "Cash",
      selector: "cash_sales",
      sortable: true,
    },
    {
      name: "Credit",
      selector: "credit_sales",
      sortable: true,
    },
    {
      name: "Credit Card",
      selector: "credit_card_sales",
      sortable: true,
    },
    {
      name: "Sodexo",
      selector: "sodexo_sales",
      sortable: true,
    },
    {
      name: "Pretty Payments",
      selector: "pretty_payments_sales",
      sortable: true,
    },
    {
      name: "Total Sales Value",
      selector: "total_sales_value",
      sortable: true,
    },
    {
      name: "Proof Images",
      selector: "proof_images",
      cell: (row) => (
        <img
          src={row.proof_images}
          alt="image"
          style={{ width: "50px", height: "50px" }}
        />
      ),
    },
    {
      name: "Difference Amount",
      selector: "difference_amount",
      sortable: true,
    },
    {
      name: "ACTIONS",
      selector: (row) => {
        const HandleEdit = async () => {
          setShow(true);
          collectionEdit(row.id);
          // handleShow(row.id);
          setModalTitle("Edit daily Collections");
        };
        const DeleteAlert = () => {
          SetRowId(row.id);
          SetAlertDeletePopupType("success");
        };
        const CancelAlerrt = () => {
          SetAlertDeletePopupType("error");
        };
        const HandleDelete = async (id) => {
          await axiosConfig
            .delete(`/accounts/daily-collection/${id}/`)
            .then(() => {
              SetAlertDeletePopupType("error");
              setDeletepopupType("success");
              GetCollections();
            })
            .catch((error) => {
              setDeletepopupType("error");
              SetAlertDeletePopupType("error");
              console.log(error);
            });
        };
        const handleRevive = async () => {
          try {
            const response = await axiosConfig.post(
              `/accounts/daily-collection/${row.id}/revive/`
            );
            setpopupType("success");
            setMessage("daily collections revived successfully");
            GetCollections();
          } catch (error) {
            console.log("Error While Reviving", error);
          }
        };
        const collectionEdit = (id) => {
          axiosConfig
            .get(`/accounts/daily-collection/${id}/`)
            .then((res) => {
              console.log(res.data, "edit");
              setFormData({
                ...res.data,
                id: res.data.id,
                store:res.data?.store?.id
              });
              setShow(true);
              setMessage("Record Updated Successfully");
            })
            .catch((error) => {
              console.log(error);
            });
        };
        return (
          <>
            {!row.is_suspended ? (
              <div className="row">
                <div className="col-4">
                  <MdOutlineEdit
                    className="dashboard-tabe-data-actions"
                    onClick={HandleEdit}
                  />
                </div>
                <div className="col-4">
                  <MdDeleteOutline
                    className="dashboard-tabe-data-actions"
                    onClick={DeleteAlert}
                  />
                </div>
              </div>
            ) : (
              <>
                <FaHandHoldingHeart
                  className="dashboard-tabe-data-actions"
                  onClick={handleRevive}
                />
              </>
            )}
            {AlertDeletePopupType === "success" && (
              <AlertDeletePopupModal
                AlertDeletePopupType={AlertDeletePopupType}
                HandleDelete={HandleDelete}
                CancelAlerrt={CancelAlerrt}
                row={RowId}
              />
            )}
          </>
        );
      },
    },
  ];
  const GetCollections = async () => {
    try {
      let response = await axiosConfig.get(
        `/accounts/daily-collection/?page=${currentPage}&page_size=${RowPerPage}&search=${debouncedSearchTerm}`
      );
      console.log(response, "data");
      SetData(response.data.results);
      setLoading(false);
      setTotalRows(response.data.count);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    GetCollections();
  }, [currentPage, RowPerPage, debouncedSearchTerm]);
  const formSubmit = async (FormData) => {
    console.log(FormData, "formdata");
    const data_to_send = {
      ...FormData,
      upi_sales: FormData.upi_sales || 0,
      cash_sales: FormData.cash_sales || 0,
      credit_sales: FormData.credit_sales || 0,
      credit_card_sales: FormData.credit_card_sales || 0,
      sodexo_sales: FormData.sodexo_sales || 0,
      pretty_payments_sales: FormData.pretty_payments_sales || 0,
      total_sales_value: FormData.total_sales_value || 0,
      proof_images: FormData.proof_images,
    };
    delete data_to_send.cuser;
    delete data_to_send.muser;
    setLoadingButton(true);
    if (typeof FormData.proof_images === "string") {
      delete data_to_send.proof_images;
    }
    axiosConfig.defaults.headers["Content-Type"] = "multipart/form-data";
    if (FormData.id) {
      await axiosConfig
        .patch(`/accounts/daily-collection/${FormData.id}/`, data_to_send)
        .then((res) => {
          console.log(res);
          setpopupType("success");
          GetCollections();
          setShow(false);
          setMessage("Record Updated Successfully");
        })
        .catch((error) => {
          console.log(error);
          let error_message = error.response.data;
          Object.values(error_message)[0] &&
            SetError(Object.values(error_message)[0]);
          setpopupType("error");
        });
      setLoadingButton(false);
    } else {
      await axiosConfig
        .post("/accounts/daily-collection/", data_to_send)
        .then((res) => {
          console.log(res);
          setpopupType("success");
          GetCollections();
          setShow(false);
        })
        .catch((error) => {
          console.log(error);
          let error_message = error.response.data;
          Object.values(error_message)[0] &&
            SetError(Object.values(error_message)[0]);
          setpopupType(error);
        });
      setLoadingButton(false);
    }
  };
  const handleClose = () => {
    setShow(false);
    SetError("");
    setpopupType("");
    setMessage("");
    setLoadingButton(false);
  };
  const handleSort = (column, direction) => {
    console.log(column.selector, direction);
    axiosConfig
      .get(
        `/accounts/daily-collection/?page=${currentPage}&page_size=${RowPerPage}&ordering=${
          direction === "asc" ? column.selector : -column.selector
        }`
      )
      .then((res) => {
        SetData(res.data.results);
      })
      .catch((error) => {
        console.log(error);
      });
    setCurrentPage(1);
  };
  const handleShow = () => {
    setShow(true);
    setFormData({
      "store":"",
      "date":today_date,
      "upi_sales":"",
      "cash_sales":"",
      "credit_sales":"",
      "credit_card_sales":"",
      "sodexo_sales":"",
      "pretty_payments_sales":"",
      "total_sales_value":"",
      "proof_images":""
    });
    setModalTitle("Add DailyCollections");
  };
  const tableCustomStyles = {
    rows: {
      style: {},
    },
    cells: {
      style: {
        justifyContent: "center",
      },
    },
    headCells: {
      style: {
        color: "#5C5C5C",
        justifyContent: "center",
        color: "rgb(33,37,41)",
        fontSize: "12px",
        fontWeight: 500,
        lineHeight: "28px",
      },
    },
  };

  return (
    <>
      <div className="child-sidenav">
        <VendorsNav />
        <div className="childnav-content">
          <div className="d-flex align-items-center">
            {/* <div className="col-4 input-cat-with-icon">
              <span className="icon-product">
                <BiSearch />
              </span>
              <input
                type="text"
                className="input-control"
                placeholder="Search"
                name="search"
                value={search.search}
                onChange={HandleSearch}
              />
            </div> */}
            <div className="cat-button ms-auto">
              <div className="btn" onClick={handleShow}>
                + Add New
              </div>
            </div>
          </div>
          <div className="table-responsive marginTop">
            <DataTable
              columns={dailyCollection_columns}
              data={Data}
              pagination
              paginationServer
              paginationTotalRows={totalRows}
              paginationPerPage={RowPerPage}
              paginationDefaultPage={currentPage}
              onChangePage={(page) => setCurrentPage(page)}
              paginationPerPageOptions={[10, 20, 25, 30, 40, 50]}
              paginationRowsPerPageOptions={[10, 20, 25, 30, 40, 50]}
              onChangeRowsPerPage={(RowsPerPageChange) =>
                setRowPerPage(RowsPerPageChange)
              }
              onSort={handleSort}
              fixedHeader
              subHeader
              customStyles={tableCustomStyles}
              progressPending={Loading}
              progressComponent={
                <div className="loader-container">
                  <img
                    src={require("../Components/FormParser/images/loader2.gif")}
                    alt="Loading..."
                  />
                </div>
              }
            />
          </div>
          <Modal
            size="xl"
            show={show}
            onHide={handleClose}
            aria-labelledby="example-modal-sizes-title-lg"
          >
            <Modal.Header closeButton>
              <Modal.Title id="example-modal-sizes-title-lg">
                {modalTitle}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <FormParser
                modelObject={MastersModal}
                formData={formData}
                formSubmit={formSubmit}
                error={Error}
                buttonTitle="Save"
                LoadingButton={LoadingButton}
              />
            </Modal.Body>
          </Modal>
          {popupType !== "" && (
            <PopupModal
              setpopupType={setpopupType}
              popupType={popupType}
              Navigation=""
              Message={message}
              error={Error}
              setMessage={setMessage}
            />
          )}
          {deletePopupType !== "" && (
            <DeletePopupModal
              setDeletepopupType={setDeletepopupType}
              deletePopupType={deletePopupType}
            />
          )}
        </div>
      </div>
    </>
  );
};
export { DailyCollection };
